'use client';

import { useState } from 'react';

import type { Country } from '@eliadmin/core/src/api/general/types/general-types';

import { RegisterDone } from './register-done';
import { RegisterForm } from './register-form';
import type { RegisteredAccount, RegisterTexts } from './types';

/**
 * Under the breadcrumbs: the H1 „Vytvoriť konto“ with the form (Figma 221:13538 / 221:13989 – 12 px
 * below the breadcrumbs, 16 on the phone, then 40 px / 24 px between the blocks), after a successful
 * registration the success card in its place (221:14567 – 32 px below the breadcrumbs, 24 on the
 * phone; its title is the page's h1 then).
 */
export function RegisterFlow({
  texts,
  countries,
  returnUrl,
}: {
  texts: RegisterTexts;
  countries: Country[];
  returnUrl?: string;
}) {
  const [account, setAccount] = useState<RegisteredAccount | null>(null);

  if (account) {
    return (
      <div className="mt-6 w-full md:mt-8">
        <RegisterDone account={account} texts={texts} returnUrl={returnUrl} />
      </div>
    );
  }

  return (
    <div className="mt-4 flex w-full max-w-[652px] flex-col gap-6 md:mt-3 md:gap-10">
      <h1 className="nt-h2 text-center text-[#0D110D]">{texts.title}</h1>
      <RegisterForm
        texts={texts}
        countries={countries}
        returnUrl={returnUrl}
        onRegistered={setAccount}
      />
    </div>
  );
}
